import { render } from "./SnailMail.vue?vue&type=template&id=6e21f85f&scoped=true"
const script = {}

import "./SnailMail.vue?vue&type=style&index=0&id=6e21f85f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e21f85f"]])

export default __exports__